<div class="menu-container" [class.expanded]="isMenuExpanded" (click)="$event.stopPropagation()">
  <div class="menu-header" [ngClass]="{ 'expanded-center-icons': !isMenuExpanded }" (click)="expand(true)">
    <img [src]="brand.logoMenu" [ngClass]="{ 'display-none': !isMenuExpanded }" class="link brand-logo-menu"
      (click)="goTo('home')" />
    <img src="assets/menu.png" class="menu-image" />

    <div class="menu-mobile-icon">
      <menu-blue [size]="40" [isMobileMenuOpen]="isMobileMenuOpen" />
    </div>
  </div>
  <div class="menu-body" [ngClass]="{ 'menu-mobile-expanded': isMobileMenuOpen }" (click)="expand(false)">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('agendamento')" (closed)="closeAccordeon('agendamento')" *ngIf="
          isModuloAtivo('Agendamento') &&
          viewMenu('listaAgendamento', 'consultar')
        " id="agendamento" class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['agendamento']" [class.not-selected]="!panelSelectedState['agendamento']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Agendamento" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/agendamento.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Agendamento
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/agendamento')"
          *ngIf="viewMenu('listaAgendamento', 'consultar')">
          Agendamentos
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          (isModuloAtivo('Report') && (
            viewMenu('graficoServicosIndicadorLimpezas', 'consultar') ||
            viewMenu('graficoServicosIndicadorAgendamentos', 'consultar') ||
            viewMenu('graficoServicosIndicadorMediaCaminhoes', 'consultar') ||
            viewMenu('graficoServicosIndicadorTerminaisAtivos', 'consultar') ||
            viewMenu('graficoServicosIndicadorReceita', 'consultar') ||
            viewMenu('graficoLimpezasPorMes', 'consultar') ||
            viewMenu('graficoLimpezasPorTerminal', 'consultar') ||
            viewMenu('graficoLimpezasPorTransportadora', 'consultar') ||
            viewMenu('graficoLimpezasAgendadas', 'consultar') ||
            viewMenu('graficoMediaMensalServico', 'consultar') ||
            viewMenu('graficoVendasQtdTipoServico', 'consultar') ||
            viewMenu('graficoVendasValorTipoServico', 'consultar') ||
            viewMenu('graficoDistribuicaoFormaPagamento', 'consultar') ||
            viewMenu('graficoValoresFormaPagamento', 'consultar') ||
            viewMenu('graficoPatioTotalVeiculos', 'consultar') ||
            viewMenu('graficoPatioAgendadoTerminais', 'consultar') ||
            viewMenu('graficoPatioTotalNoPatio', 'consultar') ||
            viewMenu('graficoPatioTempoPermanencia', 'consultar') ||
            viewMenu('graficoPatioDiarioTotal', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD1', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD2', 'consultar') ||
            viewMenu('graficoPatioEstacionamento', 'consultar') ||
            viewMenu('graficoPatioTurnos', 'consultar') ||
            viewMenu('relatorioVeiculos', 'consultar') ||
            viewMenu('historicoVeiculo', 'consultar') ||
            viewMenu('laudosEditados', 'consultar') ||
            viewMenu('financeiroMlServicos', 'consultar') ||
            viewMenu('dashboardFinanceiro', 'consultar') ||
            viewMenu('vendasPorProduto', 'consultar') ||
            viewMenu('relatorioTerminal', 'consultar') ||
            viewMenu('relatorioTerminalPdf', 'consultar') ||
            viewMenu('relatorioCarregamentoQuantitativo', 'consultar') ||
            viewMenu('relatorioCarregamentoDetalhado', 'consultar') ||
            viewMenu('relatorioClienteQuantitativo', 'consultar') ||
            viewMenu('relatorioClienteDetalhado', 'consultar') ||
            viewMenu('relatorioMensalLaudos', 'consultar') ||
            viewMenu('relatorioQuantidadeClienteLaudos', 'consultar')
          ))
        "
        (opened)="openAccordeon('relatorios')" (closed)="closeAccordeon('relatorios')" id="relatorios"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['relatorios']" [class.not-selected]="!panelSelectedState['relatorios']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Relatórios" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded
              }">
              <img src="assets/icons/logs.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Relatórios
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/dashboard-servicos')"
          *ngIf="isModuloAtivo('Report') && (
            viewMenu('graficoServicosIndicadorLimpezas', 'consultar') ||
            viewMenu('graficoServicosIndicadorAgendamentos', 'consultar') ||
            viewMenu('graficoServicosIndicadorMediaCaminhoes', 'consultar') ||
            viewMenu('graficoServicosIndicadorTerminaisAtivos', 'consultar') ||
            viewMenu('graficoServicosIndicadorReceita', 'consultar') ||
            viewMenu('graficoLimpezasPorMes', 'consultar') ||
            viewMenu('graficoLimpezasPorTerminal', 'consultar') ||
            viewMenu('graficoLimpezasPorTransportadora', 'consultar') ||
            viewMenu('graficoLimpezasAgendadas', 'consultar') ||
            viewMenu('graficoMediaMensalServico', 'consultar') ||
            viewMenu('graficoVendasQtdTipoServico', 'consultar') ||
            viewMenu('graficoVendasValorTipoServico', 'consultar') ||
            viewMenu('graficoDistribuicaoFormaPagamento', 'consultar') ||
            viewMenu('graficoValoresFormaPagamento', 'consultar')
          )">
          Dashboard Serviços
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/dashboard-patio')"
          *ngIf="isModuloAtivo('Report') && (
            viewMenu('graficoPatioTotalVeiculos', 'consultar') ||
            viewMenu('graficoPatioAgendadoTerminais', 'consultar') ||
            viewMenu('graficoPatioTotalNoPatio', 'consultar') ||
            viewMenu('graficoPatioTempoPermanencia', 'consultar') ||
            viewMenu('graficoPatioDiarioTotal', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD1', 'consultar') ||
            viewMenu('graficoPatioAgendamentosD2', 'consultar') ||
            viewMenu('graficoPatioEstacionamento', 'consultar') ||
            viewMenu('graficoPatioTurnos', 'consultar')
          )">
          Dashboard Pátio
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/dashboard-financeiro')"
          *ngIf="isModuloAtivo('Report') && viewMenu('dashboardFinanceiro', 'consultar')">
          Dashboard Financeiro
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/relatorio-veiculos')"
          *ngIf="isModuloAtivo('Report') && viewMenu('relatorioVeiculos', 'consultar')">
          Veículos
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/historico-veiculo')"
          *ngIf="isModuloAtivo('Report') && viewMenu('historicoVeiculo', 'consultar')">
          Histórico por Veículo
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/laudos-editados')"
          *ngIf="isModuloAtivo('Report') && viewMenu('laudosEditados', 'consultar')">
          Laudos Editados
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/laudos-servico')"
          *ngIf="isModuloAtivo('Report') && viewMenu('financeiroMlServicos', 'consultar')">
          Financeiro
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/relatorios-gerais')"
          *ngIf="isModuloAtivo('Report') && (
            viewMenu('relatorioTerminal', 'consultar') ||
            viewMenu('relatorioTerminalPdf', 'consultar') ||
            viewMenu('relatorioCarregamentoQuantitativo', 'consultar') ||
            viewMenu('relatorioCarregamentoDetalhado', 'consultar') ||
            viewMenu('relatorioClienteQuantitativo', 'consultar') ||
            viewMenu('relatorioClienteDetalhado', 'consultar') ||
            viewMenu('relatorioMensalLaudos', 'consultar') ||
            viewMenu('relatorioQuantidadeClienteLaudos', 'consultar')
          )">
          Relatórios Gerais
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/relatorios/relatorio-placas-caixa')"
          *ngIf="false">
          Placas - Caixa
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/estoque/relatorio-estoque')"
          *ngIf="false">
          Vendas Estoque
        </p>

        <p class="accordeon-content" (click)="goTo('listagem/relatorios/historico-alteracoes')"
          *ngIf="false">
          Histórico de Alterações
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('parametrizacao')" (closed)="closeAccordeon('parametrizacao')" *ngIf="
          isModuloAtivo('Parametrizacao') &&
          (viewMenu('parametrizacaoPatio', 'consultar') ||
            viewMenu('parametrizacaoServico', 'consultar') ||
            viewMenu('parametrizacaoPreco', 'consultar') ||
            viewMenu('parametrizacaoBlackList', 'consultar') ||
            viewMenu('parametrizacaoFila', 'consultar'))
        " id="parametrizacao" class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded" [class.selected]="panelSelectedState['parametrizacao']"
        [class.not-selected]="!panelSelectedState['parametrizacao']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Parametrização" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/parametrizacao.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Parametrização
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/patio')"
          *ngIf="viewMenu('parametrizacaoPatio', 'consultar')">
          Pátio
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/servico')"
          *ngIf="viewMenu('parametrizacaoServico', 'consultar')">
          Serviços
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/precificacao')"
          *ngIf="viewMenu('parametrizacaoPreco', 'consultar')">
          Tabela de Preços
        </p>
        <p class="accordeon-content" *ngIf="viewMenu('parametrizacaoPreco', 'consultar')"
          (click)="goTo('listagem/blacklist')">
          BlackList
        </p>
        <p class="accordeon-content" (click)="goTo('parametrizacao/fila-destinatario')"
          *ngIf="viewMenu('parametrizacaoFila', 'consultar')">
          Tipo de Fila
        </p>
        <p class="accordeon-content" (click)="goTo('parametrizacao/tolerancia')"
          *ngIf="viewMenu('parametrizacaoPatio', 'consultar')">
          Tolerância
        </p>
        <p class="accordeon-content" (click)="goTo('parametrizacao/notificacoes')"
          *ngIf="viewMenu('parametrizacaoPatio', 'consultar')">
          Notificações
        </p>
        <p class="accordeon-content" (click)="goTo('parametrizacao/janela')"
          *ngIf="viewMenu('parametrizacaoPatio', 'consultar')">
          Janela
        </p>


      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('cadastros')" (closed)="closeAccordeon('cadastros')" id="cadastros"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['cadastros']" [class.not-selected]="!panelSelectedState['cadastros']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Cadastros" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/cadastros.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Cadastros
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/transportadora')">
          Transportadoras
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('caixa')" (closed)="closeAccordeon('caixa')" *ngIf="
          (isModuloAtivo('Caixa') && viewMenu('cadastrarAberturaCaixa', 'consultar')) ||
          (isModuloAtivo('Estoque') && (viewMenu('caixaEstoque', 'consultar') || viewMenu('caixaEstoque', 'incluir')))
        " id="caixa" class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['caixa']" [class.not-selected]="!panelSelectedState['caixa']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Caixa" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/caixa.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Caixa
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/caixa')"
          *ngIf="viewMenu('cadastrarAberturaCaixa', 'consultar')">
          Movimentações
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/caixa-estoque')"
          *ngIf="isModuloAtivo('Estoque') && (viewMenu('caixaEstoque', 'consultar') || viewMenu('caixaEstoque', 'incluir'))">
          Caixa Estoque
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          isModuloAtivo('GateEntrada') &&
          (viewMenu('cadastrarGateEntrada', 'incluir') ||
            viewMenu('listaGateEntrada', 'consultar'))
        " (opened)="openAccordeon('gateEntrada')" (closed)="closeAccordeon('gateEntrada')" id="gateEntrada"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['gateEntrada']" [class.not-selected]="!panelSelectedState['gateEntrada']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Gate de Entrada" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/entrada-gate.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Gate de Entrada
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/entrada-gate')"
          *ngIf="viewMenu('listaGateEntrada', 'consultar')">
          Entradas
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/entrada')"
          *ngIf="viewMenu('cadastrarGateEntrada', 'incluir')">
          Nova Entrada
        </p>
        <p class="accordeon-content" (click)="goTo('consulta/posicao-patio')"
          *ngIf="viewMenu('listaGateEntrada', 'consultar')">
          Posição no Pátio
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          isModuloAtivo('GateSaida') &&
          (viewMenu('cadastrarGateSaida', 'incluir') ||
            viewMenu('listaGateSaida', 'consultar'))
        " (opened)="openAccordeon('gateSaida')" (closed)="closeAccordeon('gateSaida')" id="gateSaida"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['gateSaida']" [class.not-selected]="!panelSelectedState['gateSaida']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Gate de Saída" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/saida-gate.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Gate de Saída
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <p class="accordeon-content" (click)="goTo('listagem/saida-gate')"
          *ngIf="viewMenu('listaGateSaida', 'consultar')">
          Saídas
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/saida-gate')"
          *ngIf="viewMenu('cadastrarGateSaida', 'incluir')">
          Nova Saída
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          isModuloAtivo('ServicoEntrada') &&
          (viewMenu('cadastrarServico', 'incluir') ||
            viewMenu('listaServico', 'consultar'))
        " (opened)="openAccordeon('servicos')" (closed)="closeAccordeon('servicos')" id="servicos"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['servicos']" [class.not-selected]="!panelSelectedState['servicos']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Serviço" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/servicos.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Serviço
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/servicos')" *ngIf="viewMenu('listaServico', 'consultar')">
          Serviços
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/servicos')"
          *ngIf="viewMenu('cadastrarServico', 'incluir')">
          Novo Serviço
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('estoque')" (closed)="closeAccordeon('estoque')" *ngIf="
          isModuloAtivo('Estoque') &&
          (viewMenu('listaProduto', 'consultar') ||
            viewMenu('listaEstoque', 'consultar') ||
            viewMenu('listaInventario', 'consultar') ||
            viewMenu('listaMovimentacoesEstoque', 'consultar') ||
            viewMenu('graficoEstoqueIndicadores', 'consultar') ||
            viewMenu('graficoEstoqueUltimasMovimentacoes', 'consultar') ||
            viewMenu('graficoEstoqueUltimasVendas', 'consultar') ||
            viewMenu('relatorioVendasEstoque', 'consultar') ||
            viewMenu('relatorioMovimentacoesEstoque', 'consultar') ||
            viewMenu('relatorioPosicaoEstoque', 'consultar') ||
            viewMenu('relatorioClientesCaixa', 'consultar'))
        " id="estoque" class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['estoque']" [class.not-selected]="!panelSelectedState['estoque']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Estoque" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/estacionamento-tpg.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Estoque
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/estoque/produtos')"
          *ngIf="viewMenu('listaProduto', 'consultar')">
          Cadastro de Produtos
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/estoque')"
          *ngIf="viewMenu('listaEstoque', 'consultar')">
          Saldo em Estoque
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/estoque/entrada')"
          *ngIf="viewMenu('cadastrarEntradaEstoque', 'incluir')">
          Entrada de Estoque
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/estoque/saida')"
          *ngIf="viewMenu('cadastrarSaidaEstoque', 'incluir')">
          Saída de Estoque
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/estoque/dashboard')"
          *ngIf="
            viewMenu('graficoEstoqueIndicadores', 'consultar') ||
            viewMenu('graficoEstoqueUltimasMovimentacoes', 'consultar') ||
            viewMenu('graficoEstoqueUltimasVendas', 'consultar')
          ">
          Dashboard Estoque
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/estoque/relatorio-estoque')"
          *ngIf="
            viewMenu('listaInventario', 'consultar') ||
            viewMenu('listaMovimentacoesEstoque', 'consultar') ||
            viewMenu('relatorioVendasEstoque', 'consultar') ||
            viewMenu('relatorioMovimentacoesEstoque', 'consultar') ||
            viewMenu('relatorioPosicaoEstoque', 'consultar') ||
            viewMenu('relatorioClientesCaixa', 'consultar')
          ">
          Relatório Estoque
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="false" (opened)="openAccordeon('desengate')" (closed)="closeAccordeon('desengate')" id="desengate"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['desengate']" [class.not-selected]="!panelSelectedState['desengate']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Desengate" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/desengate.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Desengate
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/desengates')"
          *ngIf="viewMenu('listaDesengate', 'consultar')">
          Listagem Desengates
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/desengate')"
          *ngIf="viewMenu('cadastrarEngate', 'incluir')">
          Novo Desengate
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="false" (opened)="openAccordeon('engate')" (closed)="closeAccordeon('engate')" id="engate"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['engate']" [class.not-selected]="!panelSelectedState['engate']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Engate" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/engate.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Engate
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/engates')" *ngIf="viewMenu('listaEngate', 'consultar')">
          Listagem Engates
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/engate')" *ngIf="viewMenu('cadastrarEngate', 'incluir')">
          Novo Engate
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          isModuloAtivo('LaudoServico') &&
          (viewMenu('cadastrarLaudoHigienizacao', 'incluir') ||
            viewMenu('listaLaudoHigienizacao', 'consultar'))
        " (opened)="openAccordeon('laudosHigienizacao')" (closed)="closeAccordeon('laudosHigienizacao')"
        id="laudosHigienizacao" class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded" [class.selected]="panelSelectedState['laudosHigienizacao']"
        [class.not-selected]="!panelSelectedState['laudosHigienizacao']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Laudo de Higienização" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/laudos-higienizacao.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Laudo de Higienização
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/laudos-higienizacao')"
          *ngIf="viewMenu('listaLaudoHigienizacao', 'consultar')">
          Laudos de Higienização
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/laudo-higienizacao')"
          *ngIf="viewMenu('cadastrarLaudoHigienizacao', 'incluir')">
          Novo Laudo
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        *ngIf="
          isModuloAtivo('HigienizacaoAgendada') &&
          (viewMenu('higienizacaoAgendada', 'incluir') ||
            viewMenu('higienizacaoAgendada', 'consultar'))
        " (opened)="openAccordeon('higienizacaoAgendada')" (closed)="closeAccordeon('higienizacaoAgendada')"
        id="higienizacaoAgendada" class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded" [class.selected]="panelSelectedState['higienizacaoAgendada']"
        [class.not-selected]="!panelSelectedState['higienizacaoAgendada']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Higienização Agendada" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/higienizacao-agendada.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Higienização Agendada
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/higienizacao-agendada')"
          *ngIf="viewMenu('higienizacaoAgendada', 'consultar')">
          Higienização Agendada
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/higienizacao-agendada')"
          *ngIf="viewMenu('higienizacaoAgendada', 'incluir')">
          Nova Higienização Agendada
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('paletes')" (closed)="closeAccordeon('paletes')" *ngIf="false" id="paletes"
        class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['paletes']" [class.not-selected]="!panelSelectedState['paletes']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Tampas/Grades/Paletes" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/estacionamento-tpg.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Tampas, Grades e Paletes
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/estacionamento-tpg')"
          *ngIf="viewMenu('listaTampa', 'consultar')">
          Listagem
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/entrada-estacionamento-tpg')"
          *ngIf="viewMenu('cadastrarEntradaTampa', 'incluir')">
          Nova Entrada
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/saida-estacionamento-tpg')"
          *ngIf="viewMenu('cadastrarSaidaTampa', 'incluir')">
          Nova Saída
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('acessos-internos')" (closed)="closeAccordeon('acessos-internos')" *ngIf="
          (isModuloAtivo('Funcionario') ||
            isModuloAtivo('Perfil') ||
            isModuloAtivo('Permissao')) &&
          (viewMenu('permissaoAcesso', 'consultar') ||
            viewMenu('cadastrarPerfil', 'incluir') ||
            viewMenu('listaFuncionario', 'consultar'))
        " id="acessos-internos" class="accordeon not-selected margin-bottom"
        [class.accordeon-collapsed]="!isMenuExpanded" [class.selected]="panelSelectedState['acessos-internos']"
        [class.not-selected]="!panelSelectedState['acessos-internos']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Acesso" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/gestao-acesso.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Acesso
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/funcionario')"
          *ngIf="viewMenu('listaFuncionario', 'consultar')">
          Funcionários
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/funcionario')"
          *ngIf="viewMenu('cadastrarFuncionario', 'incluir')">
          Cadastro de Funcionário
        </p>
        <p class="accordeon-content" (click)="goTo('cadastro/parametrizacao-acessos')"
          *ngIf="viewMenu('permissaoAcesso', 'incluir')">
          Parametrização de Acessos
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('empresa')" (closed)="closeAccordeon('empresa')" *ngIf="
          isModuloAtivo('Empresa') && (viewMenu('listaEmpresa', 'consultar') || viewMenu('transferenciaEmpresaFrota', 'consultar'))
        " id="empresa" class="accordeon not-selected margin-bottom" [class.accordeon-collapsed]="!isMenuExpanded"
        [class.selected]="panelSelectedState['empresa']" [class.not-selected]="!panelSelectedState['empresa']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Empresas" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/empresa.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Empresas
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/empresa')" *ngIf="viewMenu('listaEmpresa', 'consultar')">
          Empresas Cadastradas
        </p>
        <p class="accordeon-content" (click)="goTo('listagem/empresa/transferencia')" *ngIf="viewMenu('transferenciaEmpresaFrota', 'consultar')">
          Transferência de Frota
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel #mapanel="matExpansionPanel" [hideToggle]="!isMenuExpanded" [disabled]="!isMenuExpanded"
        (opened)="openAccordeon('motoristasExterno')" (closed)="closeAccordeon('motoristasExterno')"
        id="motoristasExterno" class="accordeon not-selected margin-bottom" *ngIf="
          isModuloAtivo('MotoristaExterno') &&
          viewMenu('listaMotoristasExterno', 'consultar')
        " [class.accordeon-collapsed]="!isMenuExpanded" [class.selected]="panelSelectedState['motoristasExterno']"
        [class.not-selected]="!panelSelectedState['motoristasExterno']">
        <mat-expansion-panel-header [ngClass]="{
            'padding-0': !isMenuExpanded,
          }">
          <mat-panel-title class="accordeon-title" matTooltip="Motoristas Externo" [ngClass]="{
              'expanded-center-icons margin-right-0': !isMenuExpanded,
            }">
            <div class="menu-icon" [ngClass]="{
                'flex-center': !isMenuExpanded,
              }">
              <img src="assets/icons/motoristas-externo.svg" />
            </div>
            <p class="accordeon-text" *ngIf="isMenuExpanded" [@delayedDisplay]>
              Motoristas Externo
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="accordeon-content" (click)="goTo('listagem/motoristas-externo')"
          *ngIf="viewMenu('listaMotoristasExterno', 'consultar')">
          Listagem de Motoristas
        </p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="sair">
      <div class="menu-items margin-bottom" id="sair">
        <div class="item-image" [ngClass]="{ 'item-image-100': !isMenuExpanded }">
          <img src="assets/log-out.svg" />
        </div>
        <div class="item-content" [ngClass]="{ 'display-none': !isMenuExpanded }">
          <p class="menu-content-text" *ngIf="isMenuExpanded" [@delayedDisplay] (click)="goTo('/')">
            Sair
          </p>
        </div>
      </div>
    </mat-accordion>
  </div>
</div>